<template>
  <!--企业认证回调-->
  <div class="auth-callback">
    <!--筛选-->
    <el-row type="flex" class="row">
      <el-col :span="11"></el-col>
      <el-col :span="4">
        <el-input
          v-model="param.email"
          size="small"
          placeholder="邮箱"
          style="width: 150px;"
        />
      </el-col>
      <el-col :span="6">
        <el-date-picker
          v-model="selectParamDate"
          value-format="yyyy-MM-dd"
          :default-time="['00:00:00', '23:59:59']"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          style="width:254px"
        />
      </el-col>
      <el-col :span="3" class="text-right">
        <el-row type="flex">
          <el-col :span="12">
            <el-button @click="getDataList" size="small">查询</el-button>
          </el-col>
          <el-col :span="12">
            <el-button @click="rest" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!--列表-->
    <el-table
      :data="dataList"
      v-loading="loading"
      class="data-list"
      tooltip-effect="dark"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '500'
      }"
    >
      <el-table-column label="企业名称" prop="name" show-overflow-tooltip />
      <el-table-column label="邮箱" prop="email" show-overflow-tooltip />
      <el-table-column label="审核状态" prop="signStatusStr" />
      <el-table-column
        :filter-multiple="false"
        :filters="[
          { text: '失败', value: 4 },
          { text: '成功', value: 3 },
          { text: '正在发送', value: 2 },
          { text: '待发送', value: 1 }
        ]"
        :filter-method="filterTag"
        :filtered-value="statusFilterValue"
        prop="status"
        :label="statusFilterLabel"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.dealStatusStr }}</span>
        </template>
      </el-table-column>
      <el-table-column label="失败次数" prop="failTimes" />
      <el-table-column
        label="失败原因"
        prop="failError"
        width="160"
        show-overflow-tooltip
      />
      <el-table-column label="更新时间" prop="updateTime">
        <template slot-scope="scope">{{
          scope.row.updateTime | formatDate
        }}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <span
            @click="resendCallBack(scope.row.callBackId)"
            v-if="scope.row.dealStatus === 4 || scope.row.dealStatus === 3"
            class="options-sty color-success pointer"
            >重发</span
          >
        </template>
      </el-table-column>
      <no-data text="暂无数据" slot="empty" />
    </el-table>

    <!--分页-->
    <el-row class="pageation row">
      <el-col :span="6">
        <div style="height: 20px;"><!--占位--></div>
      </el-col>
      <el-col :span="18" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="param.itemPage"
          :page-sizes="[10, 20, 50, 100]"
          :pager-count="5"
          :page-size="param.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="param.total"
        />
        <el-go
          :page-size="param.pageSize"
          :total="param.total"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  postFindEnterpriseSignByPaged,
  postResendCallBack
} from "../../assets/js/http-serve/http-methods";
import ElGo from "../go/Go";
const paramInfo = {
  itemPage: 1,
  pageSize: 10,
  total: 0,
  beginDate: null,
  endDate: null,
  email: ""
};

export default {
  components: { ElGo },
  data() {
    return {
      dataList: [],
      // 搜索参数
      param: paramInfo,
      selectParamDate: [],
      // table表单过滤参数
      statusFilterValue: [],
      statusFilterLabel: "回调状态",
      loading: false
    };
  },
  watch: {
    selectParamDate: {
      handler(val) {
        if (val && val.length === 2) {
          this.param.beginDate = val[0];
          this.param.endDate = val[1];
        } else {
          this.param.beginDate = this.param.endDate = null;
        }
      },
      deep: true
    },
    statusFilterValue: function(val) {
      if (val.length) {
        this.statusFilterLabel =
          val[0] === 4
            ? "失败"
            : val[0] === 3
            ? "成功"
            : val[0] === 2
            ? "正在发送"
            : val[0] === 1
            ? "待发送"
            : "回调状态";
      } else {
        this.statusFilterLabel = "回调状态";
      }
    }
  },
  beforeMount() {
    this.getDataList();
  },
  methods: {
    // 重发消息
    resendCallBack(id) {
      postResendCallBack(id)
        .then(data => {
          this.$alert("更新发送状态成功", "系统提示", {
            confirmButtonText: "确定",
            type: "success"
          });
          this.getDataList();
        })
        .catch(err => {
          this.$alert("更新发送状态失败", "系统提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        });
    },
    // 重置
    rest() {
      this.param.email = "";
      this.param.itemPage = 1;
      this.param.beginDate = null;
      this.param.endDate = null;
      this.selectParamDate = [];
      this.getDataList();
    },
    // 获取企业认证回调列表
    getDataList() {
      this.loading = true;
      postFindEnterpriseSignByPaged(this.param)
        .then(data => {
          this.param.itemPage = data.pageNum;
          this.param.pageSize = data.pageSize;
          this.param.total = data.total;
          this.dataList = data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    filterTag: function(row, column) {
      return row === column.dealStatus;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.param.itemPage = 1;
      this.param.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.param.itemPage = val;
      this.getDataList();
    }
  },
  name: "auth-sign"
};
</script>

<style lang="less" scoped>
.options-sty{
  color:#290202;
}
.pageation {
  padding: 30px 10px 20px 10px;
  border-top: 0;
}
.dialog-footer {
  padding-bottom: 20px;
  .btn {
    width: 30%;
  }
}
</style>



// WEBPACK FOOTER //
// components/ent-access/entSign.vue